import React from 'react';
import {Typography} from "@mui/material";
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import {HomeStyle} from "../../../../styles/pages/home/HomeStyle";


const MessaggiCard = () => {
	const classes = HomeStyle();

	return (
		<section className={classes.card}>
			<header className={classes.cardHeader}>
				<div>
					<Typography className={classes.cardTitle}>Messaggi</Typography>
					<Typography className={classes.cardSubtitle}>
						Avvisi generali e comunicazioni operative.
					</Typography>
				</div>
			</header>

			<div className={classes.infoPanel}>
				<div className={classes.statusBox}>
					<div className={classes.metricIcon} style={{"--metric-color": "#4285F4", "--metric-color-2": "#00A8E8"}}>
						<InfoTwoToneIcon/>
					</div>
					<div>
						<Typography className={classes.actionName}>Benvenuto su Atlantis</Typography>
						<Typography className={classes.actionDescription}>
							Non ci sono nuovi messaggi da leggere.
						</Typography>
					</div>
				</div>

				<div className={classes.statusBox}>
					<div className={classes.metricIcon} style={{"--metric-color": "#34A853", "--metric-color-2": "#00A8A8"}}>
						<CheckCircleTwoToneIcon/>
					</div>
					<div>
						<Typography className={classes.actionName}>Sistema operativo</Typography>
						<Typography className={classes.actionDescription}>
							Tutte le aree principali sono disponibili.
						</Typography>
					</div>
				</div>
			</div>
		</section>
	);
};

export default React.memo(MessaggiCard);
